import React from "react";
import ResizeObserver from "resize-observer-polyfill";

export function useResizeObserver<T extends Element>() {
  const ref = React.useRef<T>(null);
  const [width, setWidth] = React.useState<number>();
  const [height, setHeight] = React.useState<number>();
  const [left, setLeft] = React.useState<number>();
  const [top, setTop] = React.useState<number>();
  const [bottom, setBottom] = React.useState<number>();
  const [right, setRight] = React.useState<number>();

  const handleResize = React.useCallback((entries: ResizeObserverEntry[]) => {
    const entry = entries[0];
    const { width, height, left, top, bottom, right } = entry.target.getBoundingClientRect();
    setWidth(width);
    setHeight(height);
    setLeft(left);
    setRight(right);
    setTop(top);
    setBottom(bottom);
  }, []);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => handleResize(entries));
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [handleResize]);

  return { ref, width, height, left, top, bottom, right };
}
